import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { AutoTranslationResponseDto } from '@/models/auto-translation/AutoTranslationResponseDto';
import { AutoTranslationRequestDto } from '@/models/auto-translation/AutoTranslationRequestDto';
import { LoadOptions } from 'devextreme/data/load_options';

export class AutoTranslationService {
  private readonly client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/AutoTranslations');
  }

  public async translate(parameters: AutoTranslationRequestDto): Promise<AutoTranslationResponseDto> {
    return await this.client.getPostData<AutoTranslationResponseDto>('', parameters);
  }

  public async getJobs(options: LoadOptions): Promise<any> {
    return await this.client.getPostData('/list', options);
  }
}
